export default analyticsRun

/** @ngInject */
function analyticsRun($rootScope, $window, $location) {
    // Google Analytics
    (function (i, s, o, g, r, a, m) {
        i.GoogleAnalyticsObject = r
        i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments)
        }

        i[r].l = Number(new Date())
        a = s.createElement(o)
        m = s.getElementsByTagName(o)[0]
        a.async = 1
        a.src = g
        m.parentNode.insertBefore(a, m)
    }(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga'))

    let trackerId
    if (['espace-client.int.plum.fr', 'espace-client.preprod.plum.fr'].indexOf($location.host()) > -1) {
        trackerId = 'UA-77876022-5'
    }
    if (['plum-energie.fr', 'espace-client.plum.fr'].indexOf($location.host()) > -1) {
        trackerId = 'UA-77876022-4'
    }

    if (trackerId) {
        $window.ga('create', trackerId, 'auto')
        $rootScope.$on('$stateChangeSuccess', (event) => {
            $window.ga('send', 'pageview', `/${$location.path()}`)

            // GA CAMPAIGN TRACKING
            if (localStorage.id_campaign) {
                $window.ga('send', {
                    hitType: 'pageview',
                    eventCategory: localStorage.id_campaign,
                    eventAction: `stateChange - ${$location.path()}`,
                    eventLabel: `${localStorage.id_campaign} Campaign Page View`,
                })
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/config/analytics.js